import { useEffect, useState } from "react";

const paths = new Set(["/dashboard", "/tenant-admin", "/team", "/messages", "/superadmin", "/docs", "/security", "/contact-widget-settings"]);
export function isPortalPath(path: string) { return paths.has(path.replace(/\/+$/u, "")); }

export function usePortalNavigation() {
  const [location, setLocation] = useState(() => window.location.href);
  useEffect(() => {
    const changed = () => setLocation(window.location.href);
    const click = (event: MouseEvent) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !isPortalPath(window.location.pathname)) return;
      const anchor = event.target instanceof Element ? event.target.closest("a[href]") : null;
      if (!(anchor instanceof HTMLAnchorElement) || anchor.hasAttribute("download") || (anchor.target && anchor.target !== "_self")) return;
      const url = new URL(anchor.href, window.location.href);
      if (url.origin !== window.location.origin || !isPortalPath(url.pathname) || url.hash) return;
      event.preventDefault();
      if (url.href !== window.location.href) window.history.pushState(null, "", url.href);
      changed();
    };
    window.addEventListener("popstate", changed);
    document.addEventListener("click", click);
    return () => { window.removeEventListener("popstate", changed); document.removeEventListener("click", click); };
  }, []);
  return location;
}
